<template>
  <div class="settings h-full flex flex-col">
    <div class="flex items-center justify-around border-b p-4 text-gray-500">
        <div class="flex items-center flex-col text-gray-700 text-sm cursor-pointer" @click="changeTab('settings')">
            <img src="@/assets/svgs/icons8-services-100.svg" class="h-8 w-8 mb-2" />
            <div>Settings</div>
        </div>
        <div class="flex items-center flex-col text-gray-700 text-sm cursor-pointer" @click="changeTab('feedback')" >
            <img src="@/assets/svgs/icons8-idea-100.svg" class="h-8 w-8 mb-2" />
            <div>Feedback</div>
        </div>
    </div>
    <div v-if="tab === 'settings'" class="h-full">
        <div class="p-4 text-gray-500">Settings will come soon!</div>
    </div>
    <div v-if="tab === 'feedback'" class="h-full bg-gray-200">
        <iframe class="clickup-embed clickup-dynamic-height" src="https://forms.clickup.com/f/q45t-253/0YR6KIDSBEIRT9MCQ6" frameborder="0" onmousewheel="" width="100%" height="100%" style="background: transparent;"></iframe>
    </div>
  </div>
</template>

<script>
    export default {
        data () {
            return {
                tab: 'settings'
            }
        },
        methods: {
            changeTab (tab) {
                this.tab = tab;
            }
        }
    }
</script>